/**
 * LSP-21826: the admin pages that offer the "Open / Get the LiveSwitch app" banner, and the Datadog
 * surface each one reports with its shown / tapped / dismissed actions. The home page is the quick
 * actions view; "async-recording" and "photo" are the Start a Recording and Take Photos pages that
 * launch the browser recorder, and "upload-photo" is Upload Photos. Each is a moment the app does the
 * same job better.
 */
export const MOBILE_APP_BANNER_ADMIN_SURFACES = {
	home: "admin-home",
	"async-recording": "admin-start-recording",
	photo: "admin-take-photos",
	"upload-photo": "admin-upload-photo"
} as const;

export type MobileAppBannerAdminSurface = (typeof MOBILE_APP_BANNER_ADMIN_SURFACES)[keyof typeof MOBILE_APP_BANNER_ADMIN_SURFACES];

/**
 * The surface for a route name, or null when that page does not offer the banner. Own keys only, so a
 * route named "toString" or "__proto__" never matches. `Object.prototype.hasOwnProperty.call` rather than
 * `Object.hasOwn`: the latter is ES2022 and missing on Safari / iOS 15.0-15.3, inside the build target,
 * and App.vue reads this for every signed-in user (break-it on PR 6480).
 */
export function mobileAppBannerSurfaceForRoute(routeName: unknown): MobileAppBannerAdminSurface | null {
	if (typeof routeName !== "string" || !Object.prototype.hasOwnProperty.call(MOBILE_APP_BANNER_ADMIN_SURFACES, routeName)) return null;
	return MOBILE_APP_BANNER_ADMIN_SURFACES[routeName as keyof typeof MOBILE_APP_BANNER_ADMIN_SURFACES];
}
